import script from "./OrderCardView.vue?vue&type=script&lang=ts&setup=true"
export * from "./OrderCardView.vue?vue&type=script&lang=ts&setup=true"

import "./OrderCardView.vue?vue&type=style&index=0&id=1130815e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1130815e"]])

export default __exports__